import { RefObject } from 'react';

import { ExpandCaret } from '@/Client/Icons';
import { FilterIcon } from '@kaiizen/kai-shiki/react';
import { DEFAULT_SCOPE_FILTER_STYLES, type ScopeFilterStyles } from './scopeFilterStyles';

const DEFAULT_LABEL = 'Filters';
const DEFAULT_ARIA_LABEL = 'Attention filters';
const testId = 'scope-attention-filter-button';

export const FilterButton = ({
  buttonRef,
  label = DEFAULT_LABEL,
  ariaLabel = DEFAULT_ARIA_LABEL,
  filterIsActive,
  open,
  onClick,
  styles = DEFAULT_SCOPE_FILTER_STYLES,
}: {
  buttonRef: RefObject<HTMLButtonElement | null>;
  label?: string;
  ariaLabel?: string;
  filterIsActive: boolean;
  open: boolean;
  onClick: () => void;
  styles?: ScopeFilterStyles;
}) => (
  <button
    ref={buttonRef}
    type={'button'}
    data-active={(filterIsActive || open) || undefined}
    css={styles.filterButton}
    aria-expanded={open}
    aria-label={ariaLabel}
    data-testid={testId}
    onClick={onClick}
  >
    <FilterIcon />
    <span>{label}</span>
    <ExpandCaret expanded={open} initialRotation={90} finalRotation={180} />
    {filterIsActive && <span css={styles.activeIndicator} />}
  </button>
);
